<template>
  <div class="log-edit-container">
    <div class="content-wrapper">
      <!-- <div class="page-header">
        <div class="header-title">{{ logType === '1' ? '工作日志登记' : '工程日志登记' }}</div>
      </div> -->

      <div class="form-cards">
        <div class="card">
          <div class="card-title">日期<span class="weekday-in-title">[{{ weekdayStr }}]</span>
            <span class="required">*</span>
          </div>
          <div class="date-input" @click="showDatePicker = true">
            <span class="date-text">{{ formData.workDate || '请选择日期' }}</span>
            <van-icon name="arrow-down" />
          </div>
        </div>

        <div class="card">
          <div class="card-title">
            {{ logType === '1' ? '当日工作完成情况' : '工程形象进度' }}
            <span class="required">*</span>
          </div>
          <textarea
            v-model="formData.workContent"
            class="form-textarea"
            :placeholder="logType === '1' ? '请填写今日已完成工作、进度、成果' : '请输入工程形象进度'"
            maxlength="900"
            rows="6"
          ></textarea>
          <div class="char-count">{{ formData.workContent.length }}/900</div>
        </div>

        <div class="card">
          <div class="card-title">
            {{ logType === '1' ? '需协调事宜或工作心得' : '工程质量情况' }}
          </div>
          <textarea
            v-model="formData.workContent1"
            class="form-textarea"
            :placeholder="logType === '1' ? '需要协调、支持、解决的问题或今日心得、总结、反思' : '请输入工程质量情况'"
            maxlength="480"
            rows="4"
          ></textarea>
          <div class="char-count">{{ formData.workContent1.length }}/480</div>
        </div>

        <div class="card">
          <div class="card-title">
            {{ logType === '1' ? '明日工作提示' : '安全生产' }}
          </div>
          <textarea
            v-model="formData.workContent2"
            class="form-textarea"
            :placeholder="logType === '1' ? '明日计划、待办、重点事项' : '请输入安全生产'"
            maxlength="480"
            rows="4"
          ></textarea>
          <div class="char-count">{{ formData.workContent2.length }}/480</div>
        </div>

        <div v-if="logType === '2'" class="card">
          <div class="card-title">甲供材进场记录</div>
          <textarea
            v-model="formData.workContent3"
            class="form-textarea"
            placeholder="请输入甲供材进场记录"
            maxlength="480"
            rows="4"
          ></textarea>
          <div class="char-count">{{ formData.workContent3.length }}/480</div>
        </div>

        <div class="card">
          <div class="card-title">附件上传</div>
          <div class="upload-area" @click="handleFileSelect">
            <van-icon name="plus" size="24" color="#8c8c8c" />
            <div class="upload-text">点击上传附件</div>
          </div>
          <input
            ref="fileInput"
            type="file"
            multiple
            style="display: none"
            @change="handleFileChange"
          />
          <div v-if="uploadedFiles.length > 0" class="file-list">
            <div
              v-for="(file, index) in uploadedFiles"
              :key="index"
              class="file-item"
            >
              <van-icon name="description" size="20" color="#0089FF" />
              <span class="file-name">{{ file.name }}</span>
              <van-icon
                name="cross"
                size="16"
                color="#8c8c8c"
                class="file-delete"
                @click.stop="handleDeleteFile(index)"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="submit-section">
        <button class="btn-submit" @click="onSubmit" :disabled="submitting || uploading">
          {{ submitting || uploading ? '处理中...' : '保 存' }}
        </button>
      </div>
    </div>

    <van-popup v-model="showDatePicker" position="bottom" round>
      <van-datetime-picker
        v-model="pickerDate"
        type="date"
        title="选择日期"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onDateConfirm"
        @cancel="showDatePicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import moment from 'moment'
import Vue from "vue"
import DailyLogService from '@/api/dailyLog/DailyLogService.js'

export default {
  name: 'LogEdit',
  data() {
    return {
      isEdit: false,
      submitting: false,
      showDatePicker: false,
      logType: '1',
      weekdayStr: '',
      minDate: new Date(moment().subtract(3, 'months').format('YYYY-MM-DD')),
      maxDate: new Date(moment().add(1, 'months').format('YYYY-MM-DD')),
      pickerDate: new Date(),
      formData: {
        workDate: moment().format('YYYY-MM-DD'),
        workContent: '',
        workContent1: '',
        workContent2: '',
        workContent3: ''
      },
      uploadedFiles: [],
      uploading: false
    }
  },
  created() {
    this.checkEditMode()
  },
  methods: {
    checkEditMode() {
      const id = this.$route.query.id
      const type = this.$route.query.type
      const date = this.$route.query.date
      const weekday = this.$route.query.weekday

      if (type) {
        this.logType = type
      }

      if (date) {
        this.formData.workDate = date
      }

      if (weekday) {
        this.weekdayStr = weekday
      }

      if (id) {
        this.isEdit = true
        this.loadLogDetail(id)
      }
    },
    loadLogDetail(id) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })

      new DailyLogService().view(id).then(res => {
        this.$toast.clear()
        this.formData = {
          workDate: res.data.workDate,
          workContent: res.data.workContent,
          workContent1: res.data.workContent1,
          workContent2: res.data.workContent2,
          workContent3: res.data.workContent3 || ''
        }
        this.logType = res.data.dailyType
        this.weekdayStr = this.getWeekdayStr(res.data.workDate)

        if (res.data.attachList) {
          this.uploadedFiles = res.data.attachList.map(f => ({
            id: f.id,
            name: f.name,
            url: f.url
          }))
        }
      }).catch(err => {
        this.$toast.fail('加载失败')
      })
    },
    onDateConfirm(value) {
      const dateStr = moment(value).format('YYYY-MM-DD')
      this.formData.workDate = dateStr
      this.weekdayStr = this.getWeekdayStr(value)
      this.showDatePicker = false
    },
    getWeekdayStr(date) {
      const weekdays = ['日', '一', '二', '三', '四', '五', '六']
      const day = moment(date).day()
      return `星期${weekdays[day]}`
    },
    onSubmit() {
      if (!this.formData.workDate) {
        this.$toast('请选择日期')
        return
      }

      if (!this.formData.workContent) {
        this.$toast(logType === '1' ? '请填写当日工作完成情况' : '请填写工程形象进度')
        return
      }

      this.submitting = true

      const data = {
        workDate: this.formData.workDate,
        dailyType: this.logType,
        workContent: this.formData.workContent,
        workContent1: this.formData.workContent1,
        workContent2: this.formData.workContent2,
        workContent3: this.formData.workContent3 || '',
        employeeId: Vue.cookie.get('userId'),
        attachIds: this.uploadedFiles.length > 0 ? JSON.stringify(this.uploadedFiles.map(f => f.id)) : ''
      }

      if (this.isEdit) {
        data.id = this.$route.query.id
      }

      new DailyLogService().save(data).then(res => {
        this.submitting = false
        this.$toast.success('保存成功')
        setTimeout(() => {
          this.$router.back()
        }, 500)
      }).catch(err => {
        this.submitting = false
        this.$toast.fail( '保存失败')
      })
    },
    handleFileSelect() {
      this.$refs.fileInput.click()
    },
    async handleFileChange(event) {
      const files = Array.from(event.target.files)
      if (files.length === 0) return

      const allowedTypes = ['png', 'jpg', 'jpeg', 'gif', 'pdf', 'zip', 'rar', 'xls', 'xlsx', 'docx', 'doc', 'dwg']
      const maxSize = 50 * 1024 * 1024

      if (this.uploadedFiles.length + files.length > 10) {
        this.$toast('附件最多只能上传10个')
        event.target.value = ''
        return
      }

      for (const file of files) {
        const fileExt = file.name.split('.').pop().toLowerCase()

        if (!allowedTypes.includes(fileExt)) {
          this.$toast(`文件格式不支持，仅支持：${allowedTypes.join(',')}`)
          event.target.value = ''
          return
        }

        if (file.size > maxSize) {
          this.$toast('文件大小不能超过50MB')
          event.target.value = ''
          return
        }
      }

      this.uploading = true
      this.$toast.loading({
        message: '上传中...',
        forbidClick: true,
        duration: 0
      })

      try {
        for (const file of files) {
          const formData = new FormData()
          formData.append('file', file)

          const res = await new DailyLogService().upload(formData)

          this.uploadedFiles.push({
            name: file.name,
            url: res.data.url,
            id: res.data.id
          })
        }

        this.$toast.clear()
        this.$toast.success('上传成功')
      } catch (err) {
        this.$toast.clear()
        this.$toast.fail('上传失败')
      } finally {
        this.uploading = false
        event.target.value = ''
      }
    },
    handleDeleteFile(index) {
      this.uploadedFiles.splice(index, 1)
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+3:wght@400;500;600;700&display=swap');

.log-edit-container {
  min-height: 100vh;
  background: #f5f7fa;
  font-family: 'Source Sans 3', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  padding-bottom: calc(80px + env(safe-area-inset-bottom));
}

.content-wrapper {
  padding: 15px;
  max-width: 480px;
  margin: 0 auto;
}

.page-header {
  margin-bottom: 15px;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a2332;
  letter-spacing: 0.5px;
}

.form-cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.2s ease;
}

.card:active {
  transform: scale(0.995);
}

.card-title {
  font-size: 15px;
  font-weight: 600;
  color: #1a2332;
  margin-bottom: 12px;
  letter-spacing: 0.3px;
}

.required {
  color: #ff4d4f;
  margin-left: 2px;
}

.date-input {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 14px;
  background: #f7f8fa;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  cursor: pointer;
  transition: all 0.2s ease;
}

.date-input:active {
  background: #f0f1f3;
  border-color: #d9d9d9;
}

.date-text {
  font-size: 15px;
  color: #1a2332;
}

.weekday-in-title {
  font-size: 15px;
  font-weight: 600;
  color: #1a2332;
  margin-left: 6px;
}

.date-input .van-icon {
  color: #8c8c8c;
  font-size: 16px;
}

.form-textarea {
  width: 100%;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 15px;
  line-height: 1.6;
  outline: none;
  resize: none;
  background: #f7f8fa;
  transition: all 0.2s ease;
  color: #1a2332;
}

.form-textarea::placeholder {
  color: #8c8c8c;
}

.form-textarea:focus {
  background: #fff;
  border-color: #0089FF;
  box-shadow: 0 0 0 2px rgba(0, 137, 255, 0.1);
}

.char-count {
  text-align: right;
  font-size: 12px;
  color: #8c8c8c;
  margin-top: 6px;
}

.upload-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  border: 2px dashed #d9d9d9;
  border-radius: 8px;
  background: #f7f8fa;
  cursor: pointer;
  transition: all 0.2s ease;
}

.upload-area:active {
  background: #f0f1f3;
  border-color: #bfbfbf;
}

.upload-text {
  font-size: 14px;
  color: #8c8c8c;
  margin-top: 8px;
}

.file-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
}

.file-item {
  display: flex;
  align-items: center;
  padding: 12px 14px;
  background: #f7f8fa;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  transition: all 0.2s ease;
}

.file-item:active {
  background: #f0f1f3;
}

.file-name {
  flex: 1;
  font-size: 14px;
  color: #1a2332;
  margin: 0 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-delete {
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.file-delete:active {
  background: rgba(0, 0, 0, 0.05);
}

.submit-section {
  margin-top: 20px;
  padding: 0 15px;
}

.btn-submit {
  width: 100%;
  background: linear-gradient(135deg, #0089FF 0%, #0070E0 100%);
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(0, 137, 255, 0.3);
}

.btn-submit:active {
  transform: scale(0.98);
  box-shadow: 0 2px 8px rgba(0, 137, 255, 0.4);
}

.btn-submit:disabled {
  background: #d9d9d9;
  box-shadow: none;
  cursor: not-allowed;
}

:deep(.van-popup) {
  border-radius: 16px 16px 0 0;
}

:deep(.van-picker__toolbar) {
  padding: 16px;
}

:deep(.van-picker__title) {
  font-size: 16px;
  font-weight: 600;
  color: #1a2332;
}

:deep(.van-picker__confirm) {
  color: #0089FF;
  font-weight: 600;
}

:deep(.van-picker__cancel) {
  color: #8c8c8c;
}
</style>
